<div class="header">
  Lista de Materiales
</div>

<button type="button" class="close" aria-label="Close" (click)="cerrar()" style="
position: absolute;
right: 7px;
top: 0px;
font-size: 30px;">
  <span aria-hidden="true" style="color: #343A40">&times;</span>
</button>

<div class="row">

  <div class="col-12 inputs">
    <div class="input-izquierda">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">N° producto</div>
        </div>
        <input [(ngModel)]="data.Code" type="text" class="form-control" placeholder="" disabled>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Cantidad</div>
        </div>
        <input [(ngModel)]="data.Qauntity" type="number" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

    <div class="input-derecha">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Almacén</div>
        </div>
        <input [(ngModel)]="data.ToWH" type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>
  </div>

  <div class="col-12 inputs">

    <div class="input-izquierda">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Descripción</div>
        </div>
        <input [(ngModel)]="data.Name" type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

    <div class="input-derecha">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Lista de precios</div>
        </div>
        <input [(ngModel)]="data.PriceList" type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

  </div>

  <div class="col-12 inputs">

    <div class="input-izquierda">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Tipo LMat</div>
        </div>
        <input [(ngModel)]="data.TreeType" type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

    <div class="input-derecha">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Norm.reparto</div>
        </div>
        <input type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

  </div>

  <div class="col-12 inputs">

    <div class="input-izquierda">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Costo estándar de producción</div>
        </div>
        <input type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

    <div class="input-derecha">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Proyecto</div>
        </div>
        <input [(ngModel)]="data.Project" type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

  </div>

  <div class="col-12 inputs">

    <div class="input-izquierda">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Tamaño producc.prom. planif.</div>
        </div>
        <input [(ngModel)]="data.PlAvgSize" type="text" class="form-control" id="inlineFormInputGroupUsername" placeholder="">
      </div>
    </div>

  </div>

  <div class="col-12" style="display: flex;justify-content: center;">
    <button (click)="crearDetalle()" mat-button style="background: #50B458;color: white;">Crear Detalle</button>
  </div>

  <div class="col-12 tabla">

    <ngx-table #table [configuration]="configuration" [data]="data.iTT1" [columns]="columns">
      <ng-template let-row let-rowIndex = index>
        <td>
          <input [(ngModel)]="row.Code" type="text">
        </td>
        <td>
          <div *ngFor="let item of row.userFields">
            <div *ngIf="item.Field == 'U_IND_Cod_antiguo'">
              <input [(ngModel)]="item.Value" type="text">
            </div>
          </div>
        </td>
        <td>
          <input [(ngModel)]="row.ItemName" type="text">
        </td>
        <td>
          <input [(ngModel)]="row.Quantity" type="number">
        </td>
        <td>
          <button (click)="borrarDetalle(rowIndex)"  mat-mini-fab color="warn" aria-label="Example icon button with a menu icon">
            <i class="fa-duotone fa-trash"></i>
          </button>
        </td>
      </ng-template>
    </ngx-table>
  </div>

  <div class="col-12" style="display: flex;justify-content: end;">
    <button (click)="crearLista()" mat-button style="background: #50B458;color: white;margin-right: 10px;margin-bottom: 10px;">{{titulo}}</button>
  </div>

</div>


